import axios from 'axios';

const api = axios.create({
    //baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5201/api',
    baseURL: "https://phase.erc.uic.edu/api",
});

export default api;